<template>
  <div class="input-component w-full" :class="[extraClass, isActive ? 'is-active' : '', !valid ? 'is-error' : '']">
    <label class="text-xs text-gray-700 cursor-text">
      {{ label }}
    </label>
    <div class="input relative">
      <input
        v-model="inputValue"
        :placeholder="placeholder"
        :aria-label="label"
        type="text"
        class="input-style placeholder-gray-600"
        @focus="onFocus"
        @blur="onBlur"
      >
    </div>

    <p v-if="!valid" class="mt-2">
      <span class="input-error bg-error text-white text-xs leading-none px-2 py-px">
        {{ errorString }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    valid: {
      type: Boolean,
      required: true,
    },
    errorString: {
      type: String,
      required: false,
      default: '',
    },
    extraClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isFocused: false,
    }
  },
  computed: {
    isActive() {
      return this.isFocused || this.inputValue
    },
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false
      this.$emit('blur', true)
    },
    onFocus() {
      this.isFocused = true
      this.$emit('focus', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.input-component {
  label {
    @apply opacity-0;

    opacity: 0;
  }
  .input {
    &::before {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 2px;
      height: 50%;
      content: '';
      background: #666;
      @apply bg-gray-600;
    }
  }
  &.is-active {
    label {
      @apply opacity-100;

      opacity: 1;
    }
    .input {
      &::before {
        display: none;
      }
    }
  }
  &.is-error {
    label {
      @apply opacity-100;

      opacity: 1;
    }
    .input {
      input {
        @apply border-error;

        border-color: #c00;
      }
      &::before {
        display: none;
      }
    }
  }
}
</style>
